import script from "./ContactDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactDetails.vue?vue&type=script&setup=true&lang=js"

import "./ContactDetails.vue?vue&type=style&index=0&id=025fa5a1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-025fa5a1"]])

export default __exports__